import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { ApplicationStatusEnum } from '@tran-monorepo/interfaces';
import { ApplicationStatusIndicatorComponent } from '../../../applications';

import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CustomControl } from '../../../form/custom-control/custom-control.component';
import { DropdownTriggerDirective } from '../../../form/dropdown/dropdown-trigger.directive';
import { DropdownComponent } from '../../../form/dropdown/dropdown.component';

@Component({
    selector: 'tran-application-status-select',
    templateUrl: './application-status-select.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ApplicationStatusIndicatorComponent, DropdownComponent, DropdownTriggerDirective],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ApplicationStatusSelectComponent),
            multi: true
        }
    ]
})
export class ApplicationStatusSelectComponent extends CustomControl<ApplicationStatusEnum> {
    protected readonly possibleStatusSelectionsInOrder: ApplicationStatusEnum[] = [
        ApplicationStatusEnum.Approved,
        ApplicationStatusEnum.Draft,
        ApplicationStatusEnum.Submitted,
        ApplicationStatusEnum.InReview,
        ApplicationStatusEnum.PreAwardCommittee,
        ApplicationStatusEnum.AwardCommittee,
        ApplicationStatusEnum.Denied,
        ApplicationStatusEnum.OnHold
    ];

    protected selectStatus(status: ApplicationStatusEnum): void {
        this.control.setValue(status);
        this.onChange(status);
        this.onTouch();
    }
}
